import { Contracts } from '../types';

const contracts: Contracts = {
  merkleRedeem: '',
  merkleOrchard: '',
  multicall: '0xFAa296891cA6CECAF2D86eF5F7590316d0A17dA0',
  authorizer: '0xAb758532D05d2A2fc7b2853ebe54Ac17fE17Ea7f',
  vault: '0x24F87b37F4F249Da61D89c3FF776a55c321B2773',
  weightedPoolFactory: '0xb13A501fA658389e437E3047d56F2Bf945207a5A',
  stablePoolFactory: '0xF9e6BE5A015Da5dc29B42ff345bB7Dd1b6C60aC7',
  lidoRelayer: '',
  balancerHelpers: '0xe007Ba1c5665567175B4d462f8dba14506e7f592',
  batchRelayer: '0xDCE2ea355530c098f5B9410b6B2663E0FFf246Bf',
  gaugeFactory: '',
  balancerMinter: '',
  gaugeController: '',
  tokenAdmin: '',
  veBAL: '',
  veDelegationProxy: '',
  veBALHelpers: '',
  feeDistributor: '',
  feeDistributorDeprecated: '',
  faucet: '',
  gaugeRewardsHelper: '',
};

export default contracts;
